export default {
  TITLE: `Problèmes d'horaire`,
  SUMMARY: ``,
  INFORMATIONS: `Informations`,
  ISSUES: `Problèmes`,
  FILTER: `Filtre`,
  SELECT_DATE_RANGE: `Veuillez choisir des dates.`,
  SHOW_RESOLVED_ISSUES: `Afficher les quarts de travail résolus`,
  NO_PERMISSION: `Permissions manquantes pour voir les problèmes.`,
  RESOLVE: `Résoudre`,
  RESOLVED: `Résolu`,
  UN_RESOLVE: `Non résolu`,
  DATE: `Date : `,
  NAME: `Nom : `,
  POSITION: `Position : `,
  EDIT_SHIFT: `Modifier le quart`,
  EDIT_POSITION: `Modifier la position`,
  EDIT_USER: `Modifier l'utilisateur`,
  PROJECTS: `Projets :`
}
